import { render, staticRenderFns } from "./MillenniumKiln.vue?vue&type=template&id=00ddd4f0&scoped=true&"
import script from "./MillenniumKiln.vue?vue&type=script&lang=js&"
export * from "./MillenniumKiln.vue?vue&type=script&lang=js&"
import style0 from "./MillenniumKiln.vue?vue&type=style&index=0&id=00ddd4f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ddd4f0",
  null
  
)

export default component.exports